import * as actions from '../statusesActions';

const initialState = {
  statuses: [],
};

const updateStatuses = (state, payload) => {
  state = Object.assign({}, state, {
    statuses: payload,
  });

  return state;
};

export default (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actions.UPDATE_STATUSES:
      return updateStatuses(state, payload);
  }
  return state;
};
